/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import React from "react";
import TemplateStep from "./TemplateStep";
import {useSelectErrorMessageList, useSelectWarningMessageList, useSelectInstructionsFormData} from "../../../../redux/ducks/Wizard/SliceProvider";
import {GeneralInfo, IBaseStepProps, Performance} from "../types";

import {Grid, Input, Typography} from '@mui/material';

const numericFields = [
  "FOV degradation", 
  "Azimuth Response", 
  "Elevation Response"
]
function isNumeric(n: string) {
  return !isNaN(parseFloat(n)) && isFinite(parseFloat(n));
}

function ListItem({listItem, indent}: any) {
  const children = listItem?.sub
  const {label, value, unit} = listItem?.form_data
  const isNumericValue = isNumeric(value);
  let shouldBeNumericField = false; 

  numericFields.forEach((numericValue: string) => {
    if (label.includes(numericValue)) {
      shouldBeNumericField = true;
    }
  }) 

  const labelColor = !value && !listItem?.sub || (shouldBeNumericField && !isNumericValue) ? 'red' : ''
  const shouldInput = !listItem?.sub
  return (
    <div style={{marginLeft: indent}}>
      <div style={{fontSize: 12}}>
        <span style={{color: labelColor}}>{label}</span>
        {<Input disabled value={value ?? ''}
                style={{marginLeft: 4, width: "300px",display: !shouldInput ? 'none' : 'inline-block', fontSize: 12}}/>}
        {unit}
      </div>
      {Array.isArray(children) && <List list={children} indent={indent + 30}/>}
    </div>
  );
}

function List({list, indent}: any) {
  return (
    <div>
      {list?.map((listItem: any, index: number) => (
        <ListItem key={listItem.value + '-' + index + '-' + indent} listItem={listItem} indent={indent ?? 0}/>
      ))}
    </div>
  );
}

type InstructionsStepType = 'general_info' | 'performance'

interface IInstructionsStep extends IBaseStepProps {
  type: InstructionsStepType
  indexForErrorMessages: number
  indexForWarningMessages: number
}

export const InstructionsStep = (props: IInstructionsStep) => {
  const {messagesTitle} = props
  const errorMessages = useSelectErrorMessageList(props.indexForErrorMessages)
  const warningMessages = useSelectWarningMessageList(props.indexForWarningMessages)
  const formData: Performance | GeneralInfo | undefined = useSelectInstructionsFormData()?.[props.type]

  const content2f = (
    <Grid container sx={{p: 0}}>
      <Grid item xs={8} sx={{mb: 1}}>
        <Typography variant="h6">{formData?.title}</Typography>
      </Grid>
      <Grid item xs={8} className="full-form">
        <List list={formData?.data}/>
      </Grid>
    </Grid>
  )

  return (
    <TemplateStep content1={null} content2={content2f} warningMessages={warningMessages} errorMessages={errorMessages} isFirstWizardStep={false}
                  isLastWizardStep={false}
                  messagesTitle={messagesTitle} customTopRow={null}
    />
  );
};